var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.24 45.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#5a29b3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M22.62,0C10.13,0,0,10.13,0,22.62s10.13,22.62,22.62,22.62,22.62-10.13,22.62-22.62S35.11,0,22.62,0Zm13.41,23.66H11.78l9.12,8.88c.2,.19,.31,.46,.32,.73,0,.28-.1,.54-.3,.74-.2,.2-.47,.32-.75,.32s-.53-.1-.73-.3l-11.02-10.7v-.02l-.03-.05c-.07-.09-.14-.23-.18-.39l-.02-.12c-.02-.15-.01-.28,.02-.42v-.24l.14-.07c.04-.06,.09-.12,.14-.17l10.96-10.67c.41-.4,1.07-.39,1.48,.02,.4,.41,.39,1.08-.02,1.48l-9.12,8.88h24.25c.58,0,1.04,.47,1.04,1.04s-.47,1.04-1.04,1.04Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightOut);
export default __webpack_public_path__ + "static/media/right-out.2fb2bfb376eba2e555299cf2a800a87a.svg";
export { ForwardRef as ReactComponent };